module.exports = __webpack_public_path__ + "img/ic_nav_music-on.ef03da43.svg";